import React, { Fragment, HTMLAttributes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Conditional } from '../../../components/ConditionalField';
import _ from 'lodash';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { CheckBoxGroup } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { TextInputGroup } from 'sos-common/js/components/FormControls/TextInputGroup';
import { GroupedComponentsValidator } from 'sos-common/js/components/FormControls/GroupedComponentsValidator';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { FieldStates, FormFieldFile, FormField } from 'sos-common/js/commonTypes/formField.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ValidationResult, StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import {
  ResearchOrderStore,
  ResearchOrderRegisters,
  researchOrderFiles,
  ResearchOrderClientErrors,
} from '../../../models/ResearchOrderStore.types';
import {
  setFormValue,
  addFilesAction,
  addFileActionFunc,
  removeFilesAction,
  removeFileActionFunc,
  clearErrorDispatcher,
  clearError,
} from 'sos-eservice-common/js/Redux/Actions';
import { ResearchOrderModel } from '../../../models/ResearchOrderModel';
import {
  fileInputAcceptedTypes,
  getErrorMessageByFieldName,
  getErrorMessageByFieldNameAfterHitSummary,
  allScopedResearchOrderFiles2SelectBoxOptions,
  mandatoryIfNotOnlyDeceased,
} from '../../../utilities/helpers';
import Asterix from 'sos-common/js/components/Asterix/Asterix';
import { shortuid } from 'sos-common/js/utils/guid';
export interface Step1Props extends StepChildProps {
  Translate?: translateFunc;
  registers?: ResearchOrderRegisters;
  setFormValue?: typeof setFormValue;
  researchOrder: ResearchOrderModel;
  hasHitSummary: boolean;
  deleteFile: removeFileActionFunc;
  postFile: addFileActionFunc;
  clearError: clearError;
  researchOrderId: string;
  files: researchOrderFiles;
  validationResults: ValidationResult[];
  fullValidationResults: ValidationResult[];
  stepValidationMap: StepValidationMap;
  errors: ResearchOrderClientErrors;
}
export interface Step1State {
  showQuality: boolean;
  externalRegistriesShown: boolean;
  showOtherRegistries: boolean;
  isValid: boolean;
  stepId: number;
  createdByUsTouched: boolean;
}

function showOtherRegistriesCalc(arr: string[]): boolean {
  if (arr.length === 0) {
    return false;
  }
  if (arr.length === 1 && arr[0].length === 0) {
    return false;
  }
  return true;
}

class Step1 extends React.Component<Step1Props, Step1State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isValid: this.props?.stepState?.isDone,
      showQuality: !!_.get(this.props.researchOrder, 'DataSources.QualityRegisters.length', 0),
      externalRegistriesShown: !!_.get(this.props.researchOrder, 'DataSources.ExternalRegisters.length', 0),
      showOtherRegistries: showOtherRegistriesCalc(_.get(this.props.researchOrder, 'DataSources.OtherRegisters', [])),
      stepId: this.props?.stepState?.stepId,
      createdByUsTouched: false,
    };
  }
  public getTitle = () => 'Projektet';

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }
  render() {
    const { Translate, registers, researchOrder, files, hasHitSummary, researchOrderId, validationResults, errors } =
      this.props;
    const noResearchOrderId = !researchOrderId;
    const HasPriorOrdersErrorMessageObject = this.getGroupedErrorMessageObject(
      'CurrentResearchOrder.HasPriorOrders',
      this.props.validationResults,
      true,
    );
    const CreatedByUsErrorMessageObject = this.getGroupedErrorMessageObject(
      'CurrentResearchOrder.StudyPopulation.CreatedByUs',
      this.props.fullValidationResults,
      false,
    );
    return (
      <div id="step1" tabIndex={-1}>
        <p>{Translate('/orderFormPage/starOblig')}</p>
        <div className="form-group">
          <label className="inlineblock h2" htmlFor="currentResearchOrderTitle">
            {Translate('/orderFormPage/title')}
          </label>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfobubblorForskarBestallning/ForskningsProjektTitelPaSv')} />
          </div>
          <TextInput
            id="currentResearchOrderTitle"
            placeholder={Translate('/orderFormPage/titleplaceholder')}
            value={_.get(researchOrder, 'Title')}
            isRequired={true}
            maxLength={160}
            fieldName="CurrentResearchOrder.Title"
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.Title')}
          />
        </div>
        <div className="form-group" role="group" aria-labelledby="hasPriorityOrdersLabel">
          <h2 id="hasPriorityOrdersLabel" className="inlineblock">
            {Translate('/orderFormPage/haspriororders')}
          </h2>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfobubblorForskarBestallning/HarDuBestallDataTillDettaProjTid')} />
          </div>
          <br />

          <GroupedComponentsValidator
            errorId={HasPriorOrdersErrorMessageObject.id}
            errorMessage={HasPriorOrdersErrorMessageObject.errorMessage}>
            <Conditional showConditional={researchOrder.HasPriorOrders}>
              {{
                top: (
                  <div>
                    <RadioButton
                      fieldName="CurrentResearchOrder.HasPriorOrders"
                      onChange={this.onChangeField}
                      checked={researchOrder.HasPriorOrders}
                      value={true}
                      label={Translate('/global/yes')}
                      isRequired={true}
                      errorAriaAttributes={HasPriorOrdersErrorMessageObject.ariaAttributes}
                    />
                  </div>
                ),
                bottom: (
                  <div>
                    <RadioButton
                      fieldName="CurrentResearchOrder.HasPriorOrders"
                      onChange={this.onChangeField}
                      value={false}
                      checked={researchOrder.HasPriorOrders !== null && !researchOrder.HasPriorOrders}
                      label={Translate('/global/no')}
                      isRequired={true}
                      errorAriaAttributes={HasPriorOrdersErrorMessageObject.ariaAttributes}
                    />
                  </div>
                ),
                conditional: (
                  <div className={'form-group-small'}>
                    <div className={'form-group-small'}>
                      <TextInput
                        placeholder={Translate('/orderFormPage/referenceplaceholder')}
                        fieldName="CurrentResearchOrder.ReferenceNumberPriorOrder"
                        label={Translate('/orderFormPage/referencenumberspriororders')}
                        onChange={this.onChangeField}
                        maxLength={160}
                        value={_.get(researchOrder, 'ReferenceNumberPriorOrder')}
                      />
                    </div>
                    <CheckBox
                      fieldName="CurrentResearchOrder.PdfOnlyPriorOrders.NyaArgangar"
                      label={Translate('/orderformpage/NyaArgangar_PriorOrders')}
                      onChange={this.onChangeField}
                      value={_.get(researchOrder, 'PdfOnlyPriorOrders.NyaArgangar')}
                    />
                    <CheckBox
                      fieldName="CurrentResearchOrder.PdfOnlyPriorOrders.NyaVariabler"
                      label={Translate('/orderformpage/NyaVariabler_PriorOrders')}
                      onChange={this.onChangeField}
                      value={_.get(researchOrder, 'PdfOnlyPriorOrders.NyaVariabler')}
                    />
                    <Conditional showConditional={_.get(researchOrder, 'PdfOnlyPriorOrders.Annat')}>
                      {{
                        top: (
                          <CheckBox
                            fieldName="CurrentResearchOrder.PdfOnlyPriorOrders.Annat"
                            label={Translate('/orderformpage/Annat_PriorOrders')}
                            onChange={this.onChangeField}
                            value={_.get(researchOrder, 'PdfOnlyPriorOrders.Annat')}
                          />
                        ),
                        conditional: (
                          <div className="indent">
                            <TextInput
                              fieldName="CurrentResearchOrder.PdfOnlyPriorOrders.AngeVad"
                              placeholder={Translate('/orderFormPage/Annat_AngeVad_PriorOrder')}
                              label={Translate('/orderFormPage/AngeVad_PriorOrders')}
                              onChange={this.onChangeField}
                              maxLength={160}
                              value={_.get(researchOrder, 'PdfOnlyPriorOrders.AngeVad')}
                              isRequired={true}
                              errorMessage={getErrorMessageByFieldName(
                                validationResults,
                                'CurrentResearchOrder.PdfOnlyPriorOrders.AngeVad',
                              )}
                            />
                          </div>
                        ),
                      }}
                    </Conditional>
                  </div>
                ),
              }}
            </Conditional>
          </GroupedComponentsValidator>
        </div>
        <hr className="formdivider" />
        <div className="form-group" role="group" aria-labelledby="studiepopulationenAvlidnaLabel">
          <h2 id="studiepopulationenAvlidnaLabel">{Translate('/orderFormPage/studiepopulationenAvlidna')}</h2>
          <RadioButtonGroup
            value={_.get(researchOrder, 'StudyPopulation.OnlyDeceased')}
            fieldName="CurrentResearchOrder.StudyPopulation.OnlyDeceased"
            onChange={this.onChangeField}
            isRequired={true}>
            <RadioButton value="Ja" label="Ja" />
            <RadioButton value="Nej" label="Nej" />
            <RadioButton value="Vet ej" label="Vet ej" />
          </RadioButtonGroup>
        </div>
        <hr className="formdivider" />
        <div>
          <div role="group" aria-labelledby="dokumentSomSkaBifogasLabel">
            <h2 id="dokumentSomSkaBifogasLabel" className="inlineblock">
              {Translate('/orderFormPage/submitdocuments')}
            </h2>
            <Tooltip text={Translate('/InfobubblorForskarBestallning/DokumentSomSkaBifogas')} />

            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/ansokanEtik')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="ansokanEtik"
              value={files.ansokanEtik}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.ansokanEtik}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ansokanEtik')}
              mandatory={mandatoryIfNotOnlyDeceased(researchOrder)}
              maxFileSize={33554432}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 32 MB.'}
            />
            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/forskningsplan')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="forskningsplan"
              value={files.forskningsplan}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.forskningsplan}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.forskningsplan')}
              mandatory={true}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 10 MB.'}
            />
            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/OvrigTillEtik')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="ovrigtilletik"
              max={30}
              value={files.ovrigtilletik}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.ovrigtilletik}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ovrigtilletik')}
              maxFileSize={33554432}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 32 MB.'}
            />
            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/beslutEtik')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="beslutetik"
              value={files.beslutetik}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.beslutetik}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.beslutetik')}
              mandatory={mandatoryIfNotOnlyDeceased(researchOrder)}
              maxFileSize={33554432}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 32 MB.'}
            />
            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/tillagAnsokanEtik')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="tillagansokanetik"
              value={files.tillagansokanetik}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              max={30}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.tillagansokanetik}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.tillagansokanetik')}
              maxFileSize={33554432}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 32 MB.'}
            />
            <Fileupload
              disabled={noResearchOrderId}
              heading={Translate('/orderformpage/tillagBeslutEtik')}
              upload={Translate('/orderformpage/uploadFile')}
              nofilesText={Translate('/orderformpage/noFilesUploaded')}
              fieldName="tillagbeslutetik"
              value={files.tillagbeslutetik}
              onAdd={this.addFiles}
              onRemove={this.removeFile}
              max={30}
              mimetype={fileInputAcceptedTypes}
              clientError={errors.tillagbeslutetik}
              errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.tillagbeslutetik')}
              maxFileSize={33554432}
              allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 32 MB.'}
            />
          </div>
          <hr className="formdivider" />

          <div className="form-group-xs-small">
            <div>
              <label className="inlineblock h2" htmlFor="beskrivStudiepopulationen">
                {Translate('/orderFormPage/studypopulation')}
              </label>
              <div className="inlineblock">
                <Tooltip text={Translate('/InfobubblorForskarBestallning/BeskrivStudiepopulationen')} />
              </div>
              <br />
              <p>{Translate('/orderformpage/studypopulationinfo')}</p>
            </div>

            <div className="form-group-small">
              <label>{Translate('/orderformpage/shouldSelectPartOfPopulation')}</label>
              <RadioButtonGroup
                value={_.get(researchOrder, 'StudyPopulation.ShouldSelectPartOfPopulation')}
                fieldName="CurrentResearchOrder.StudyPopulation.ShouldSelectPartOfPopulation"
                onChange={this.onChangeField}
                isRequired={false}>
                <RadioButton value="Ja" label={Translate('/global/yes')} />
                <RadioButton value="Nej" label={Translate('/global/no')} checked={true} />
              </RadioButtonGroup>
            </div>

            {_.get(researchOrder, 'StudyPopulation.ShouldSelectPartOfPopulation') === 'Ja' && (
              <div className="indent">
                <div className="form-group-small">
                  <label>{Translate('/orderformpage/selectionCriteria')}</label>
                  <TextInput
                    multiline
                    maxLength={4000}
                    fieldName="CurrentResearchOrder.StudyPopulation.SelectionCriteria"
                    value={_.get(researchOrder, 'StudyPopulation.SelectionCriteria')}
                    placeholder={Translate('/orderformpage/selectionCriteriaPlaceholder')}
                    onChange={this.onChangeField}
                    isRequired={true}
                    errorMessage={getErrorMessageByFieldName(
                      validationResults,
                      'CurrentResearchOrder.StudyPopulation.SelectionCriteria',
                    )}
                  />
                </div>
              </div>
            )}

            <div className="form-group-small">
              <TextInput
                id="beskrivStudiepopulationen"
                classNames="height240px"
                multiline
                maxLength={4000}
                fieldName="CurrentResearchOrder.StudyPopulation.HowToCreatePopulation"
                value={_.get(researchOrder, 'StudyPopulation.HowToCreatePopulation')}
                placeholder={Translate('/orderformpage/beskrivStudiePopulation')}
                onChange={this.onChangeField}
                isRequired={true}
                errorMessage={getErrorMessageByFieldName(
                  validationResults,
                  'CurrentResearchOrder.StudyPopulation.HowToCreatePopulation',
                )}
              />
            </div>

            <div className="form-group" role="group" aria-labelledby="angeSidaOchFilLabel">
              <Asterix showAsterix={mandatoryIfNotOnlyDeceased(researchOrder)}>
                <h2 id="angeSidaOchFilLabel">{Translate('/orderFormpage/angeSidaOchFil')}</h2>
              </Asterix>
              <div className="row">
                <label className="sr-only" htmlFor="angeSidaStudioPopulation">
                  {Translate('/orderFormpage/valjFil')}
                </label>
                <div className="col-md-6">
                  <SelectBox
                    id="angeSidaStudioPopulation"
                    options={allScopedResearchOrderFiles2SelectBoxOptions(files)}
                    value={_.get(researchOrder, 'StudyPopulation.DescriptionInApplication.FileId', undefined)}
                    fieldName="CurrentResearchOrder.StudyPopulation.DescriptionInApplication.FileId"
                    onChange={this.onChangeField}
                    isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
                    errorMessage={getErrorMessageByFieldName(
                      validationResults,
                      'CurrentResearchOrder.StudyPopulation.DescriptionInApplication.FileId',
                    )}
                  />
                </div>
                <div className="col-md-6">
                  <label className="sr-only" htmlFor="angeFilStudioPopulation">
                    {Translate('/orderFormpage/angeSidaAvsnitt')}
                  </label>
                  <TextInput
                    id="angeFilStudioPopulation"
                    fieldName="CurrentResearchOrder.StudyPopulation.DescriptionInApplication.Page"
                    placeholder={Translate('/orderFormpage/SidaAvsnittNoStar')}
                    maxLength={50}
                    onChange={this.onChangeField}
                    value={_.get(researchOrder, 'StudyPopulation.DescriptionInApplication.Page', '')}
                    isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
                    errorMessage={getErrorMessageByFieldName(
                      validationResults,
                      'CurrentResearchOrder.StudyPopulation.DescriptionInApplication.Page',
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="h2" htmlFor="uppskattaIndivider">
                {Translate('/orderFormpage/uppskattaIndivider')}
              </label>
              <TextInput
                id="uppskattaIndivider"
                type="text"
                maxLength={11}
                actAsNumber={true}
                fieldName="CurrentResearchOrder.StudyPopulation.EstimatedPopulationSize"
                placeholder={Translate('/orderFormpage/antalIndivider')}
                onChange={this.onChangeField}
                value={_.get(researchOrder, 'StudyPopulation.EstimatedPopulationSize')}
                isRequired={true}
                errorMessage={getErrorMessageByFieldName(
                  validationResults,
                  'CurrentResearchOrder.StudyPopulation.EstimatedPopulationSize',
                )}
              />
            </div>
            <hr className="formdivider" />
            <div className="form-group" role="group" aria-labelledby="vilkaSkapaPopulationenLabel">
              <h2 id="vilkaSkapaPopulationenLabel">{Translate('/orderFormpage/vilkaSkapaPopulationen')}</h2>

              <GroupedComponentsValidator
                errorId={CreatedByUsErrorMessageObject.id}
                errorMessage={CreatedByUsErrorMessageObject.errorMessage}
                delayErrorRender={70}>
                <CheckBox
                  fieldName="CurrentResearchOrder.StudyPopulation.CreatedByUs"
                  label={Translate('/orderformpage/Socialstyrelsen')}
                  onChange={this.onChangeCreatedByUs}
                  value={_.get(researchOrder, 'StudyPopulation.CreatedByUs')}
                  errorAriaAttributes={CreatedByUsErrorMessageObject.ariaAttributes}
                />
                <CheckBox
                  fieldName="CurrentResearchOrder.StudyPopulation.CreatedByThem"
                  label={Translate('/orderformpage/EgenPopulation')}
                  onChange={this.onChangeCreatedByUs}
                  value={_.get(researchOrder, 'StudyPopulation.CreatedByThem')}
                  errorAriaAttributes={CreatedByUsErrorMessageObject.ariaAttributes}
                />
                <CheckBox
                  fieldName="CurrentResearchOrder.StudyPopulation.CreatedByOtherAuthority"
                  label={Translate('/orderformpage/AndraRegisterHallare')}
                  onChange={this.onChangeCreatedByUs}
                  value={_.get(researchOrder, 'StudyPopulation.CreatedByOtherAuthority')}
                  errorAriaAttributes={CreatedByUsErrorMessageObject.ariaAttributes}
                />
                <Conditional showConditional={_.get(researchOrder, 'StudyPopulation.SavedKeyExist')}>
                  {{
                    top: (
                      <CheckBox
                        fieldName="CurrentResearchOrder.StudyPopulation.SavedKeyExist"
                        label={Translate('/orderformpage/SparadNyckel')}
                        onChange={this.onChangeCreatedByUs}
                        value={_.get(researchOrder, 'StudyPopulation.SavedKeyExist')}
                        errorMessage={getErrorMessageByFieldName(
                          validationResults,
                          'CurrentResearchOrder.StudyPopulation.SavedKeyExist',
                        )}
                        errorAriaAttributes={CreatedByUsErrorMessageObject.ariaAttributes}
                      />
                    ),
                    conditional: (
                      <div className="indent">
                        <TextInput
                          label={Translate('/orderformpage/HosVem')}
                          fieldName="CurrentResearchOrder.StudyPopulation.SavedKeyLocation"
                          placeholder={Translate('/orderFormpage/MyndighetSparadNyckel')}
                          onChange={this.onChangeField}
                          maxLength={160}
                          value={_.get(researchOrder, 'StudyPopulation.SavedKeyLocation')}
                          isRequired={true}
                          errorMessage={getErrorMessageByFieldName(
                            validationResults,
                            'CurrentResearchOrder.StudyPopulation.SavedKeyLocation',
                          )}
                        />
                      </div>
                    ),
                  }}
                </Conditional>
              </GroupedComponentsValidator>
            </div>

            <div className="form-group" role="group" aria-labelledby="vilkaDatakallorLabel">
              <h2 className="inlineblock" id="vilkaDatakallorLabel">
                {Translate('/orderFormpage/VilkaDatakallor')}
              </h2>
              <div className="inlineblock">
                <Tooltip
                  text={
                    'OBS: Behöver du data från register som inte Socialstyrelsen hanterar, till exempel från SCB eller ett kvalitetsregister, måste du göra separata beställningar därifrån.'
                  }
                />
              </div>
              <CheckBox
                fieldName="CurrentResearchOrder.DataSources.ProprietaryData"
                label={Translate('/orderformpage/EgenData')}
                onChange={this.onChangeField}
                value={_.get(researchOrder, 'DataSources.ProprietaryData')}
                errorMessage={getErrorMessageByFieldName(
                  validationResults,
                  'CurrentResearchOrder.DataSources.ProprietaryData',
                )}
              />
              <Conditional indent={true} showConditional={this.state.showQuality}>
                {{
                  top: (
                    <CheckBox
                      fieldName="QualityRegistersAreChoosen"
                      value={this.state.showQuality}
                      label={Translate('/orderformpage/Kvalitetsregister')}
                      onChangeCallback={this.handleShowQuality}
                      // onChange={this.handleShowQuality}
                    />
                  ),
                  conditional: (
                    <CheckBoxGroup
                      fieldName="CurrentResearchOrder.DataSources.QualityRegisters"
                      value={_.get(researchOrder, 'DataSources.QualityRegisters', [])}
                      onChange={this.onChangeField}
                      errorMessage={getErrorMessageByFieldName(
                        validationResults,
                        'CurrentResearchOrder.DataSources.QualityRegisters',
                      )}>
                      {registers.qualityRegistries.map((reg) => (
                        <CheckBox key={reg.DhsId} stringValue={reg.DhsId} label={reg.Name} />
                      ))}
                    </CheckBoxGroup>
                  ),
                }}
              </Conditional>

              <Conditional indent={true} showConditional={this.state.externalRegistriesShown}>
                {{
                  top: (
                    <CheckBox
                      fieldName="ExternalRegistersAreChoosen"
                      label={Translate('/orderformpage/AndraRegister')}
                      onChangeCallback={this.handleShowExternal}
                      value={this.state.externalRegistriesShown}
                    />
                  ),
                  conditional: (
                    <CheckBoxGroup
                      fieldName="CurrentResearchOrder.DataSources.ExternalRegisters"
                      value={_.get(researchOrder, 'DataSources.ExternalRegisters', [])}
                      onChange={this.onChangeField}
                      errorMessage={getErrorMessageByFieldName(
                        validationResults,
                        'CurrentResearchOrder.DataSources.ExternalRegisters',
                      )}>
                      {registers.externalRegistries.map((reg) => (
                        <CheckBox key={reg.DhsId} stringValue={reg.DhsId} label={reg.Name} />
                      ))}
                    </CheckBoxGroup>
                  ),
                }}
              </Conditional>
              <Conditional indent={true} showConditional={this.state.showOtherRegistries}>
                {{
                  top: (
                    <CheckBox
                      fieldName="OtherDataSourcesExists"
                      onChangeCallback={this.handleShowOtherReg}
                      label={Translate('/orderformpage/AnnanDatakällor')}
                      value={this.state.showOtherRegistries}
                    />
                  ),
                  conditional: (
                    <Fragment>
                      <div className="like-a-label">{Translate('/orderformpage/VilkenEllerVilkaDatakällor')}</div>
                      <TextInputGroup
                        value={_.get(researchOrder, 'DataSources.OtherRegisters', [])}
                        maxItems={7}
                        onChange={this.onChangeField}
                        maxLength={34}
                        fieldName="CurrentResearchOrder.DataSources.OtherRegisters"
                        placeholder="Datakälla"
                        errorMessage={getErrorMessageByFieldName(
                          validationResults,
                          'CurrentResearchOrder.DataSources.OtherRegisters',
                        )}
                      />
                    </Fragment>
                  ),
                }}
              </Conditional>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private setCreatedByUsTouched = () => {
    this.setState({
      createdByUsTouched: true,
    });
  };

  private handleShowQuality = () => {
    this.setState((prevState) => {
      return {
        showQuality: !prevState.showQuality,
      };
    });
  };
  private handleShowExternal = () => {
    this.setState((prevState) => {
      return {
        externalRegistriesShown: !prevState.externalRegistriesShown,
      };
    });
  };
  private handleShowOtherReg = () => {
    this.setState((prevState) => {
      return {
        showOtherRegistries: !prevState.showOtherRegistries,
      };
    });
  };

  private addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  };
  private removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };

  private onChangeCreatedByUs = (field: FieldStates) => {
    if (!this.state.createdByUsTouched) this.setCreatedByUsTouched();
    this.onChangeField(field);
  };

  private onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  };

  private getGroupedErrorMessageObject = (fieldName: string, validationResults, afterHitSummary: boolean) => {
    const { hasHitSummary } = this.props;
    let errorMessage = '';

    if (!this.state.createdByUsTouched && !hasHitSummary)
      return { errorMessage: '', id: fieldName + '-errormessage', ariaAttributes: {} };

    if (afterHitSummary) {
      errorMessage = getErrorMessageByFieldNameAfterHitSummary(validationResults, fieldName, hasHitSummary);
    } else {
      errorMessage = getErrorMessageByFieldName(validationResults, fieldName);
    }

    const id = fieldName + '-errormessage';
    let ariaAttributes = {} as HTMLAttributes<any>;
    if (errorMessage) {
      ariaAttributes['aria-invalid'] = true;
      ariaAttributes['aria-describedby'] = id;
    } else {
      ariaAttributes = null;
    }
    return { errorMessage, id, ariaAttributes };
  };
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    registers: state.registers,
    researchOrder: state.formModel,
    researchOrderId: state.globals.orderId,
    hasHitSummary: state.globals.hasHitSummary,
    files: state.files,
    validationResults: state.validationState.validationResults,
    fullValidationResults: state.validationState.fullValidationResults,
    stepValidationMap: state.validationState.stepValidationMap,
    errors: state.errors,
  } as Step1Props;
};

const mapDispatch2Props = (dispatch) => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    clearError: clearErrorDispatcher(dispatch),
  };
};

const StepOne = connect(mapState2Props, mapDispatch2Props)(Step1);
export { StepOne };
